import React from 'react';
import SEO from './SEO';
import './FarmHistory.css';

const FarmHistory = () => {
  return (
    <>
      <SEO 
        title="Notre Histoire - La Ferme À L'Ancienne"
        description="Découvrez l'histoire de La Ferme À L'Ancienne : exploitation familiale depuis 1936, certification agriculture biologique depuis 2009. Notre engagement pour le bien-être animal et l'environnement au Lude (72800)."
        keywords="histoire ferme bio, exploitation familiale Le Lude, agriculture biologique 72800, ferme traditionnelle, producteur viande bio, histoire boucherie Le Lude"
        canonical="https://lafermeancienne.fr/histoire"
      />
      <main className="farm-history">
        <div className="container">
          <article className="history-content">
            <section className="history-section">
              <div className="history-text">
                <h1>Notre histoire</h1>
              <p>
                Exploitation familiale depuis 1936 et en agriculture biologique depuis 2009,
                nous avons à coeur mon conjoint et moi, de vous donner une viande de qualité avec des valeurs et des principes qui sont dans le respect des la nature et du bien être animal.
              </p>
              <div className="history-ab-logo">
                <img src="/images/AB.png" alt="Certification Agriculture Biologique depuis 2009" />
              </div>
            </div>
            <div className="history-image">
              <img 
                src="/images/AERIENNE.png" 
                alt="Vue aérienne de La Ferme À L'Ancienne au Lude (72800) - Exploitation agricole biologique"
                className="history-img"
              />
            </div>
          </section>
        </article>
      </div>
    </main>
    </>
  );
};

export default FarmHistory;
